import { SPLIT_PAYMENT_TYPES } from 'constants/index';
import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  cardIdsToAmountsMap: {},
  editPaymentState: {
    checkedCCOptions: [],
    checkedGCOptions: [],
  },
  splitPaymentState: {
    splitType: SPLIT_PAYMENT_TYPES.EXACT_AMOUNT,
    splitPercents: {},
  },
  isPEDPayment: false,
  sledValue: '',
};

const selectPayment = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.SELECT_PAYMENT_CONFIRM:
      return Object.assign({}, state, {
        splitPaymentState: {
          splitType: payload.splitType,
          // For compatability with SplitPaymentContext
          splitPercents: payload.initialValues,
        },
        cardIdsToAmountsMap: payload.cardIdsToAmountsMap,
      });

    case actionTypes.SELECT_PAYMENT_CHECK_CREDIT_CARDS:
      return Object.assign({}, state, {
        editPaymentState: {
          ...state.editPaymentState,
          checkedCCOptions: payload,
        },
      });

    case actionTypes.SELECT_PAYMENT_CHECK_GIFT_CARDS:
      return Object.assign({}, state, {
        editPaymentState: {
          ...state.editPaymentState,
          checkedGCOptions: payload,
        },
      });

    case actionTypes.SELECT_PAYMENT_SET_AMOUNTS_MAP:
      return {
        ...state,
        cardIdsToAmountsMap: payload,
      };

    case actionTypes.SELECT_PAYMENT_RESET_SELECTION:
      return Object.assign({}, state, {
        cardIdsToAmountsMap: payload,
        editPaymentState: {
          checkedCCOptions: [],
          checkedGCOptions: [],
        },
      });

    case actionTypes.SELECT_PAYMENT_SWITCH_PED:
      return {
        ...state,
        isPEDPayment: payload,
        // reset sledValue on switch of PED payment
        sledValue: payload ? state.sledValue : '',
      };

    case actionTypes.SELECT_PAYMENT_SELECT_SLED:
      return {
        ...state,
        sledValue: payload,
      };

    case actionTypes.SELECT_PAYMENT_RESET_STATE:
      return { ...INITIAL_STATE };

    default:
      return state;
  }
};

export default selectPayment;
